import axios, { type AxiosInstance } from "axios";

const API_BASE_URL = (import.meta.env.VITE_API_URL as string) || "http://localhost:8000/api/v1";

export const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  // SSO (Wave K): allow the .veyuhub.com cookie set by /auth/login to
  // travel on every API call so admin recognises an already-authenticated
  // user from cabinet / crm without a second login.
  withCredentials: true,
});

const TOKEN_KEY = "veyu_admin_access_token";

export const tokenStorage = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (token: string) => localStorage.setItem(TOKEN_KEY, token),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

apiClient.interceptors.request.use((config) => {
  const token = tokenStorage.get();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      tokenStorage.clear();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);
